import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as platform from '../../../base/common/platform.js';
import { EditorZoom } from './editorZoom.js';
/**
 * Determined from empirical observations.
 * @internal
 */

var GOLDEN_LINE_HEIGHT_RATIO = platform.isMacintosh ? 1.5 : 1.35;
/**
 * @internal
 */

var MINIMUM_LINE_HEIGHT = 8;
export var BareFontInfo = /*#__PURE__*/function () {
  /**
   * @internal
   */
  function BareFontInfo(opts) {
    _classCallCheck(this, BareFontInfo);

    this.zoomLevel = opts.zoomLevel;
    this.fontFamily = String(opts.fontFamily);
    this.fontWeight = String(opts.fontWeight);
    this.fontSize = opts.fontSize;
    this.fontFeatureSettings = opts.fontFeatureSettings;
    this.lineHeight = opts.lineHeight | 0;
    this.letterSpacing = opts.letterSpacing;
  }
  /**
   * @internal
   */


  _createClass(BareFontInfo, [{
    key: "getId",
    value:
    /**
     * @internal
     */
    function getId() {
      return this.zoomLevel + '-' + this.fontFamily + '-' + this.fontWeight + '-' + this.fontSize + '-' + this.fontFeatureSettings + '-' + this.lineHeight + '-' + this.letterSpacing;
    }
    /**
     * @internal
     */

  }, {
    key: "getMassagedFontFamily",
    value: function getMassagedFontFamily() {
      if (/[,"']/.test(this.fontFamily)) {
        // Looks like the font family might be already escaped
        return this.fontFamily;
      }

      if (/[+ ]/.test(this.fontFamily)) {
        // Wrap a font family using + or <space> with quotes
        return "\"".concat(this.fontFamily, "\"");
      }

      return this.fontFamily;
    }
  }], [{
    key: "createFromValidatedSettings",
    value: function createFromValidatedSettings(options, zoomLevel, ignoreEditorZoom) {
      var fontFamily = options.get(35
      /* fontFamily */
      );
      var fontWeight = options.get(39
      /* fontWeight */
      );
      var fontSize = options.get(38
      /* fontSize */
      );
      var fontFeatureSettings = options.get(37
      /* fontLigatures */
      );
      var lineHeight = options.get(51
      /* lineHeight */
      );
      var letterSpacing = options.get(48
      /* letterSpacing */
      );
      return BareFontInfo._create(fontFamily, fontWeight, fontSize, fontFeatureSettings, lineHeight, letterSpacing, zoomLevel, ignoreEditorZoom);
    }
    /**
     * @internal
     */

  }, {
    key: "_create",
    value: function _create(fontFamily, fontWeight, fontSize, fontFeatureSettings, lineHeight, letterSpacing, zoomLevel, ignoreEditorZoom) {
      if (lineHeight === 0) {
        lineHeight = Math.round(GOLDEN_LINE_HEIGHT_RATIO * fontSize);
      } else if (lineHeight < MINIMUM_LINE_HEIGHT) {
        lineHeight = MINIMUM_LINE_HEIGHT;
      }

      var editorZoomLevelMultiplier = 1 + (ignoreEditorZoom ? 0 : EditorZoom.getZoomLevel() * 0.1);
      fontSize *= editorZoomLevelMultiplier;
      lineHeight *= editorZoomLevelMultiplier;
      return new BareFontInfo({
        zoomLevel: zoomLevel,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontSize: fontSize,
        fontFeatureSettings: fontFeatureSettings,
        lineHeight: lineHeight,
        letterSpacing: letterSpacing
      });
    }
  }]);

  return BareFontInfo;
}();
export var FontInfo = /*#__PURE__*/function (_BareFontInfo) {
  _inherits(FontInfo, _BareFontInfo);

  var _super = _createSuper(FontInfo);

  /**
   * @internal
   */
  function FontInfo(opts, isTrusted) {
    var _this;

    _classCallCheck(this, FontInfo);

    _this = _super.call(this, opts);
    _this.isTrusted = isTrusted;
    _this.isMonospace = opts.isMonospace;
    _this.typicalHalfwidthCharacterWidth = opts.typicalHalfwidthCharacterWidth;
    _this.typicalFullwidthCharacterWidth = opts.typicalFullwidthCharacterWidth;
    _this.canUseHalfwidthRightwardsArrow = opts.canUseHalfwidthRightwardsArrow;
    _this.spaceWidth = opts.spaceWidth;
    _this.middotWidth = opts.middotWidth;
    _this.wsmiddotWidth = opts.wsmiddotWidth;
    _this.maxDigitWidth = opts.maxDigitWidth;
    return _this;
  }
  /**
   * @internal
   */


  _createClass(FontInfo, [{
    key: "equals",
    value: function equals(other) {
      return this.fontFamily === other.fontFamily && this.fontWeight === other.fontWeight && this.fontSize === other.fontSize && this.fontFeatureSettings === other.fontFeatureSettings && this.lineHeight === other.lineHeight && this.letterSpacing === other.letterSpacing && this.typicalHalfwidthCharacterWidth === other.typicalHalfwidthCharacterWidth && this.typicalFullwidthCharacterWidth === other.typicalFullwidthCharacterWidth && this.canUseHalfwidthRightwardsArrow === other.canUseHalfwidthRightwardsArrow && this.spaceWidth === other.spaceWidth && this.middotWidth === other.middotWidth && this.wsmiddotWidth === other.wsmiddotWidth && this.maxDigitWidth === other.maxDigitWidth;
    }
  }]);

  return FontInfo;
}(BareFontInfo);